import { render, staticRenderFns } from "./PresentationList.vue?vue&type=template&id=c413953a&"
import script from "./PresentationList.vue?vue&type=script&lang=js&"
export * from "./PresentationList.vue?vue&type=script&lang=js&"
import style0 from "./PresentationList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports